module.exports = __webpack_public_path__ + "static/media/features_bg.f0da765f.jpg";